import { useEffect } from 'react';
import { useBreadcrumbs } from '../contexts/BreadcrumbContext';

/**
 * Sets the merged header/breadcrumb row title in the TopBar (ENG-2297).
 * List pages call this instead of rendering their own in-page `Heading`.
 * Pass `documentTitle` when the browser tab should differ from the in-app title
 * (Home keeps "Welcome, …" in the header and "Home" in the tab).
 */
const usePageTitle = (title: string, documentTitle?: string) => {
    const { setBreadcrumbs, clearBreadcrumbs } = useBreadcrumbs();

    useEffect(() => {
        setBreadcrumbs([], title, documentTitle);
        return () => clearBreadcrumbs();
    }, [title, documentTitle, setBreadcrumbs, clearBreadcrumbs]);
};

export default usePageTitle;
